
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","viewBox":"0 0 24 25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 .39)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v23.76H0z"}}),_c('rect',{attrs:{"width":"24","height":"23.76","fill":"#593289","fill-opacity":".1","rx":"11.88"}}),_c('g',{attrs:{"stroke":"#593289","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.5"}},[_c('path',{attrs:{"d":"M9 8.91l6 5.94M15 8.91l-6 5.94"}})])])])
          )
        }
      }
    